/*  JS of Custom Cart Drawer Section
    Added by Wilson from Galadrim
*/

(function () {
  if (!document.body) return;

  let VP_REQ_ID = 0;

  // ---------------------------------------------------------------------------
  // UTILITY FUNCTIONS
  // ---------------------------------------------------------------------------

  function debounce(func, wait, immediate) {
    let timeout;
    return function () {
      const context = this,
        args = arguments;
      const later = function () {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      const callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }

  function setDrawerActive(active) {
    const drawer = document.querySelector("[data-custom-cart-drawer]");
    const overlay = document.querySelector("[data-custom-cart-drawer-overlay]");
    if (!drawer || !overlay) return;

    drawer.classList.toggle("active", active);
    overlay.classList.toggle("active", active);
    document.body.style.overflow = active ? "hidden" : "";

    // Re-highlight tiers when opening the drawer
    if (active) {
      const totalQty = getTotalCartItemCount();
      drawer.querySelectorAll(".search-flydown--product-card").forEach(card => {
        const grid = card.querySelector(".b2b-pricing-grid");

        if (grid && totalQty > 0) {
          highlightCurrentTier(grid, totalQty);
        }
      });
    }
  }

  function preventConfirm(e) {
    e.preventDefault();
    e.stopPropagation();
  }

  /**
   * Calcule le nombre total d'items dans le panier (tous produits confondus)
   * @returns {number} Le nombre total d'items dans le panier
   */
  function getTotalCartItemCount() {
    let total = 0;

    // Check if we're in cart drawer
    const drawer = document.querySelector("#CartDrawer");
    if (drawer && drawer.classList.contains("active")) {
      drawer.querySelectorAll(".quantity-selector__input").forEach(input => {
        const value = parseInt(input.value, 10) || 0;
        total += value;
      });
      return total;
    }

    // Check if we're on cart page
    if (window.location.pathname === "/cart") {
      document.querySelectorAll(".cart-item input[name='updates[]']").forEach(input => {
        const value = parseInt(input.value, 10) || 0;
        total += value;
      });
      return total;
    }

    // Fallback: try to count from any available quantity inputs
    document.querySelectorAll(".quantity-selector__input, input[name='updates[]']").forEach(input => {
      const value = parseInt(input.value, 10) || 0;
      total += value;
    });

    return total;
  }

  /* ---------- Helper functions for cart operations ---------- */
  async function handleRelativeChange(variantId, delta) {
    // Get cart item data from the DOM - find the product card specifically
    const cartItem = document.querySelector(`.search-flydown--product-card[data-variant-id="${variantId}"]`);

    if (!cartItem) {
      throw new Error(`Cart item not found for variant ${variantId}`);
    }

    const itemKey = cartItem.getAttribute("data-cartitem-key");
    const currentQuantity = parseInt(cartItem.getAttribute("data-quantity") || "0", 10);
    const newQuantity = currentQuantity + delta;

    if (currentQuantity > 0) {
      // Item exists, update with new quantity
      // Use Empire theme's cart update pattern with FormData
      const formData = new FormData();
      formData.append("updates[" + itemKey + "]", newQuantity);

      const response = await fetch("/cart/update.js", {
        method: "POST",
        body: formData,
      });
      return response;
    } else {
      // Item doesn't exist, add it
      // Use Empire theme's cart add pattern with FormData
      const formData = new FormData();
      formData.append("id", variantId);
      formData.append("quantity", delta);

      const response = await fetch("/cart/add.js", {
        method: "POST",
        body: formData,
      });
      return response;
    }
  }

  async function handleAbsoluteChange(variantId, quantity) {
    // Get cart item data from the DOM - find the product card specifically
    const cartItem = document.querySelector(`.search-flydown--product-card[data-variant-id="${variantId}"]`);
    if (!cartItem) {
      throw new Error(`Cart item not found for variant ${variantId}`);
    }

    const itemKey = cartItem.getAttribute("data-cartitem-key");
    const currentQuantity = parseInt(cartItem.getAttribute("data-quantity") || "0", 10);

    if (currentQuantity > 0) {
      // Item exists, update with new quantity
      // Use Empire theme's cart update pattern with FormData
      const formData = new FormData();
      formData.append("updates[" + itemKey + "]", quantity);

      const response = await fetch("/cart/update.js", {
        method: "POST",
        body: formData,
      });
      return response;
    } else {
      // Item doesn't exist, add it
      // Use Empire theme's cart add pattern with FormData
      const formData = new FormData();
      formData.append("id", variantId);
      formData.append("quantity", quantity);

      const response = await fetch("/cart/add.js", {
        method: "POST",
        body: formData,
      });
      return response;
    }
  }

  /* ---------- Custom cart helper  (robust) ---------- */
  async function customCartRequest(variantId, { delta = null, quantity = null }) {
    try {
      /* 1-call the custom-app endpoint */
      const res =
        delta !== null
          ? await handleRelativeChange(variantId, delta) // relative (+1 / -1)
          : await handleAbsoluteChange(variantId, quantity); // absolute (= n)

      /* 2—normalise the result                                          
          – some apps return a Response object,                         
          – others give the cart JSON directly,                         
          – and your app currently returns { cartToken: "…" }.          */
      let cart;

      // a) Response-like -> json()
      if (res && typeof res.ok === "boolean") {
        if (!res.ok) throw new Error(`HTTP ${res.status || "---"} from custom cart`);
        cart = await res.json();
      } else {
        cart = res; // already JSON
      }

      // b) If the payload has no items, pull the real cart from /cart.js

      // [FACTO]
      // if (!cart || !cart.items) {
      //   const freshCartResponse = await fetch("/cart.js");
      //   if (freshCartResponse.ok) {
      //     cart = await freshCartResponse.json();
      //   } else {
      //     throw new Error("Failed to fetch fresh cart");
      //   }
      // }

      cart = Shopify.cart;

      /* 3—broadcast + return */
      document.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart } }));
      return cart;
    } catch (err) {
      console.error("[CartDrawer] request failed:", err);
      throw err; // caller will roll back the UI
    }
  }

  /* ------------------------------------------------------------------
   customCartRemove: cleanly removes a line using the Shopify Ajax API
   ------------------------------------------------------------------ */
  async function customCartRemove(lineId) {
    try {
      /* call Shopify Ajax API ➜ /cart/change.js */
      // Use Empire theme's cart change pattern with JSON
      const fetchBody = {
        id: lineId,
        quantity: 0,
      };

      const res = await fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(fetchBody),
      });

      if (!res.ok) {
        throw new Error(`HTTP ${res.status} from cart change API`);
      }

      const cart = await res.json();

      /* broadcast the update everywhere */
      document.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart } }));

      // Dispatch cartcount:update event like Empire theme
      const countEvent = new CustomEvent("cartcount:update", {
        detail: cart,
      });
      window.dispatchEvent(countEvent);

      return cart;
    } catch (err) {
      console.error("[CartDrawer] remove failed:", err);
      throw err;
    }
  }

  // ---------------------------------------------------------------------------
  // CONFIRM BUTTON WATCHER (limits & errors)
  // ---------------------------------------------------------------------------

  function updateCartDrawerConfirmButton() {
    const confirmBtn = document.querySelector(".custom-cart-drawer .button-primary[data-cart-confirm-btn]");
    if (!confirmBtn) return;

    let atLimit = false;
    let itemAtLimit = null;

    document.querySelectorAll(".custom-cart-drawer--item-error").forEach(e => e.remove());

    const cards = document.querySelectorAll(".custom-cart-drawer .search-flydown--product-card");

    cards.forEach(card => {
      const input = card.querySelector(".quantity-selector__input");
      if (!input) return;

      const value = parseInt(input.value, 10) || 1;
      let max = parseInt(input.getAttribute("max"), 10);
      if (isNaN(max)) {
        max = parseInt(input.getAttribute("data-customer-limit"), 10);
      }

      const inventoryQuantity = parseInt(card.getAttribute("data-inventory-quantity"), 10);
      const inventoryPolicy = card.getAttribute("data-inventory-policy");
      const inventoryManagement = card.getAttribute("data-inventory-management");

      const hasInventoryLimit =
        inventoryManagement === "shopify" && inventoryPolicy === "deny" && !isNaN(inventoryQuantity);

      if ((!isNaN(max) && value > max) || (hasInventoryLimit && value > inventoryQuantity)) {
        atLimit = true;
        itemAtLimit = itemAtLimit || card;
      }
    });

    if (atLimit) {
      confirmBtn.classList.add("disabled", "limit-disabled");
      confirmBtn.setAttribute("aria-disabled", "true");
      confirmBtn.addEventListener("click", preventConfirm, true);
      confirmBtn.setAttribute("href", "#");
      confirmBtn.style.pointerEvents = "none";
      confirmBtn.style.opacity = "0.5";

      if (itemAtLimit) {
        const actionsWrapper = itemAtLimit.querySelector(".search-flydown--product-actions");
        if (
          actionsWrapper &&
          !actionsWrapper.nextElementSibling?.classList.contains("custom-cart-drawer--item-error")
        ) {
          const errorElement = document.createElement("div");
          errorElement.className = "custom-cart-drawer--item-error";
          errorElement.style.cssText = "width:100%;text-align:left;padding:8px 0;color:#B42318;";
          errorElement.textContent =
            "La quantité dépasse le maximum autorisé, veuillez réduire la quantité pour continuer.";
          actionsWrapper.insertAdjacentElement("afterend", errorElement);
        }
      }
    } else {
      confirmBtn.classList.remove("disabled", "limit-disabled");
      confirmBtn.removeAttribute("aria-disabled");
      confirmBtn.removeEventListener("click", preventConfirm, true);
      confirmBtn.setAttribute("href", window.routes?.cart_url || "/cart");
      confirmBtn.style.pointerEvents = "";
      confirmBtn.style.opacity = "";
    }
  }

  // ---------------------------------------------------------------------------
  // PARTIAL REFRESH : volume‑pricing grid only
  // ---------------------------------------------------------------------------

  function getLineQty(line) {
    /* ① First, check if the theme has already set a data-attribute */
    const attr = line.querySelector("[data-quantity]")?.dataset.quantity;
    if (attr) return parseInt(attr, 10);

    /* ② otherwise, take the value from the updates[] input */
    const inp = line.querySelector('input[name="updates[]"], .quantity__input');
    return inp ? parseInt(inp.value, 10) : NaN;
  }

  function highlightCurrentTier(grid, qty) {
    const prices = grid.querySelectorAll(".b2b-pricing-grid__price");

    prices.forEach(price => {
      price.classList.remove("current-tier");

      const min = parseInt(price.getAttribute("data-min"), 10) || 0;
      const max = parseInt(price.getAttribute("data-max"), 10) || Infinity;

      if (qty >= min && qty <= max) {
        price.classList.add("current-tier");
      }
    });
  }
  // Expose the function globally so predictive search can use it
  window.highlightCurrentTier = highlightCurrentTier;

  function refreshVolumePricingGrid(card, qty) {
    const handle = card.getAttribute("data-product-handle");
    const variantId = card.getAttribute("data-variant-id");
    if (!handle || !variantId) return;

    const url =
      `/products/${handle}?variant=${variantId}` +
      `&section_id=volume-pricing-only` + // <- HTML
      `&quantity=${qty}`;

    const reqId = ++VP_REQ_ID;

    fetch(url)
      .then(r => r.text())
      .then(html => {
        if (reqId !== VP_REQ_ID) return; // a more recent request exists
        const doc = new DOMParser().parseFromString(html, "text/html");
        const newGrid = doc.querySelector(".b2b-pricing-grid");
        const oldGrid = card.querySelector(".b2b-pricing-grid");
        if (!newGrid || !oldGrid) return;

        oldGrid.replaceWith(newGrid);
        const totalQty = getTotalCartItemCount();
        highlightCurrentTier(newGrid, totalQty);
      })
      .catch(err => console.error("[CartDrawer] refresh grid :", err));
  }

  /* ---------------------------------------------------------------------------
   QUANTITY HANDLING  (cart‑drawer only)
   --------------------------------------------------------------------------- */

  /* Helper for total  */
  function refreshDrawerSubtotalOptimistic() {
    const totalEl = document.querySelector(".custom-cart-drawer__total span:last-child");
    if (!totalEl) return;

    let cents = 0;
    document.querySelectorAll(".custom-cart-drawer .search-flydown--product-card").forEach(card => {
      const unit = parseInt(card.dataset.unitPriceCents, 10);
      const qtyEl = card.querySelector(".quantity-selector__input");
      const qty = qtyEl ? parseInt(qtyEl.value, 10) : 0;
      if (!isNaN(unit) && !isNaN(qty)) cents += unit * qty;
    });

    totalEl.textContent = (cents / 100).toLocaleString("fr-FR", {
      style: "currency",
      currency: "EUR",
    });
  }

  const variantLock = new Map(); // one lock per variant

  function updateQuantity(input, delta) {
    /* ---------- 1. limits & clamping ---------- */
    const min = parseInt(input.getAttribute("min"), 10) || 1;
    const card = input.closest(".search-flydown--product-card");
    if (!card) return;

    const variantId = card.getAttribute("data-variant-id");
    if (!variantId) return;

    /* ────────────────────────────────────────────────────────────────────
     💡  Anti‑spam lock: if a request for this variant is still running,
         we ignore further clicks until it finishes.
     ──────────────────────────────────────────────────────────────────── */
    if (variantLock.get(variantId)) return;

    variantLock.set(variantId, true);

    const plusBtn = card.querySelector(".quantity-selector__button--plus");
    const minusBtn = card.querySelector(".quantity-selector__button--minus");

    const customerLimit = parseInt(input.getAttribute("data-customer-limit"), 10);
    const inventoryQuantity = parseInt(card.getAttribute("data-inventory-quantity"), 10);
    const inventoryPolicy = card.getAttribute("data-inventory-policy");
    const inventoryManagement = card.getAttribute("data-inventory-management");

    let effectiveMax;
    if (inventoryManagement === "shopify" && inventoryPolicy === "deny") {
      effectiveMax = !isNaN(customerLimit) ? Math.min(customerLimit, inventoryQuantity) : inventoryQuantity;
    } else if (!isNaN(customerLimit)) {
      effectiveMax = customerLimit;
    } else {
      effectiveMax = inventoryQuantity || Infinity;
    }

    const currentValue = parseInt(input.value, 10) || min;
    let newValue = currentValue + delta;

    if (!isNaN(effectiveMax) && newValue > effectiveMax) newValue = effectiveMax;
    if (newValue < min) newValue = min;
    if (newValue === currentValue) return;
    variantLock.set(variantId, true);

    /* ---------- 2. optimistic UI ---------- */
    input.value = newValue;
    /* ---- instant (optimistic) line‑price refresh ---- */
    const unitPrice = parseInt(card.dataset.unitPriceCents, 10);
    if (!isNaN(unitPrice)) {
      const priceEl = card.querySelector(".search-flydown--product-price");
      if (priceEl) {
        priceEl.textContent = ((unitPrice * newValue) / 100).toLocaleString("fr-FR", {
          style: "currency",
          currency: "EUR",
        });
      }
    }

    // ---- optimistic cart total ----
    refreshDrawerSubtotalOptimistic();

    /* ---------- 3. backend call ---------- */
    customCartRequest(variantId, { delta }) // relative change
      .then(cart => {
        /* -- find the item returned by the API -- */
        const updatedItem = cart.items?.find(it => it.variant_id == variantId);

        /* ---- line price (server) ---- */
        const priceEl = card.querySelector(".search-flydown--product-price");
        if (priceEl) {
          // if the backend did not return the item, keep the estimate
          const finalCents = updatedItem ? updatedItem.final_line_price : unitPrice * newValue;
          priceEl.textContent = (finalCents / 100).toLocaleString("fr-FR", {
            style: "currency",
            currency: "EUR",
          });
        }

        /* ---- cart total ---- */
        const totalEl = document.querySelector(".custom-cart-drawer__total span:last-child");
        if (totalEl) {
          const cents = cart.total_price || cart.items.reduce((s, i) => s + i.final_line_price, 0);
          totalEl.textContent = (cents / 100).toLocaleString("fr-FR", {
            style: "currency",
            currency: "EUR",
          });
        }

        /* Update DOM attributes with the new quantity from API response */
        if (updatedItem) {
          card.setAttribute("data-quantity", updatedItem.quantity);
        } else {
          // Item was removed from cart (quantity = 0)
          card.setAttribute("data-quantity", "0");
        }

        updateCartDrawerConfirmButton();

        /* ask promos module to rebuild */
        document.dispatchEvent(new CustomEvent("promos:refresh"));
      })
      .catch(err => {
        console.error("[CartDrawer] quantity update failed:", err);
        /* rollback UI to the last known good value */
        input.value = currentValue;
        refreshDrawerSubtotalOptimistic();
      })
      .finally(() => {
        /* unlock + restore button states */
        variantLock.delete(variantId);
        if (plusBtn) plusBtn.disabled = !isNaN(effectiveMax) && parseInt(input.value, 10) >= effectiveMax;
        if (minusBtn) minusBtn.disabled = parseInt(input.value, 10) <= min;
      });
  }

  // ---------------------------------------------------------------------------
  // GLOBAL API (open / close / full refresh when necessary)
  // ---------------------------------------------------------------------------

  window.openCustomCartDrawer = () => setDrawerActive(true);
  window.closeCustomCartDrawer = () => setDrawerActive(false);
  window.customCartRemove = customCartRemove;
  window.getTotalCartItemCount = getTotalCartItemCount;

  window.refreshCartDrawerSection = function () {
    return fetch(window.location.pathname + "?sections=custom-cart-drawer")
      .then(res => {
        if (!res.ok) throw new Error("[CartDebug] HTTP error fetching cart drawer section!");
        return res.json();
      })
      .then(data => {
        if (!data || !data["custom-cart-drawer"]) return;

        const drawerToReplace = document.querySelector("[data-custom-cart-drawer]");
        if (!drawerToReplace) return;

        const wasActive = drawerToReplace.classList.contains("active");

        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = data["custom-cart-drawer"];
        const newDrawerElement = tempDiv.firstElementChild;
        if (!newDrawerElement) return;

        drawerToReplace.replaceWith(newDrawerElement);
        if (wasActive) setDrawerActive(true);

        // force execution of injected scripts
        newDrawerElement.querySelectorAll("script").forEach(oldScript => {
          const newScript = document.createElement("script");
          Array.from(oldScript.attributes).forEach(attr => newScript.setAttribute(attr.name, attr.value));
          newScript.appendChild(document.createTextNode(oldScript.innerHTML));
          oldScript.parentNode.replaceChild(newScript, oldScript);
        });

        document.dispatchEvent(new CustomEvent("cart-drawer:refreshed"));
      })
      .catch(err => console.error("[CartDebug] Error in refreshCartDrawerSection:", err));
  };

  // ---------------------------------------------------------------------------
  // MAIN EVENT HANDLERS
  // ---------------------------------------------------------------------------

  function handleBodyClick(e) {
    const target = e.target;

    // Close the drawer
    if (target.matches("[data-custom-cart-drawer-overlay]") || target.closest(".custom-cart-drawer__close")) {
      window.closeCustomCartDrawer();
      return;
    }

    // +/- quantity
    const quantitySelector = target.closest(".quantity-selector");
    if (quantitySelector && target.closest(".custom-cart-drawer")) {
      const input = quantitySelector.querySelector(".quantity-selector__input");
      if (!input) return;
      if (target.classList.contains("quantity-selector__button--plus")) {
        updateQuantity(input, 1);
      }
      if (target.classList.contains("quantity-selector__button--minus")) {
        updateQuantity(input, -1);
      }
      return;
    }

    // remove item (via Custom API)
    const removeBtn = target.closest(
      ".custom-cart-drawer .cart-drawer-remove-btn, .custom-cart-drawer a.cart-item__remove-link_drawer"
    );
    if (removeBtn) {
      e.preventDefault();
      e.stopImmediatePropagation();

      const card = removeBtn.closest(".search-flydown--product-card");
      const lineKey = card.dataset.cartitemKey;

      if (!lineKey) {
        console.error("Cart item key not found");
        return;
      }

      /* visual animation */
      card?.classList.add("removing");

      customCartRemove(lineKey)
        .then(cart => {
          /* refresh / rebuild the drawer */
          if (typeof window.refreshCartDrawerSection === "function") {
            window.refreshCartDrawerSection();
          }
        })
        .catch(err => {
          console.error("Error removing item from drawer:", err);
          card?.classList.remove("removing");
        });
    }
  }

  function handleManualQuantityChange(e) {
    if (!e.target.matches(".custom-cart-drawer .quantity-selector__input")) return;

    const input = e.target;
    const oldValue = parseInt(input.getAttribute("data-old-value") || input.value, 10);
    const newValue = parseInt(input.value, 10);
    if (isNaN(oldValue) || isNaN(newValue) || oldValue === newValue) return;

    input.value = oldValue; // visual rollback
    updateQuantity(input, newValue - oldValue);
  }

  function storeOldValueOnFocus(e) {
    if (e.target.matches(".custom-cart-drawer .quantity-selector__input")) {
      e.target.setAttribute("data-old-value", e.target.value);
    }
  }

  // ---------------------------------------------------------------------------
  // INITIALIZATION
  // ---------------------------------------------------------------------------

  function attachConfirmButtonWatchers(drawer) {
    if (!drawer) return;
    drawer.addEventListener("input", updateCartDrawerConfirmButton, true);
    drawer.addEventListener("change", updateCartDrawerConfirmButton, true);
  }

  function initializeCartDrawer() {
    if (window.location.pathname === "/cart") {
      const totalQty = getTotalCartItemCount();
      document.querySelectorAll(".cart-item").forEach(line => {
        const grid = line.querySelector(".b2b-pricing-grid");
        if (grid && totalQty > 0) highlightCurrentTier(grid, totalQty);
      });
    }
    document.body.addEventListener("click", handleBodyClick);
    document.body.addEventListener("focusin", storeOldValueOnFocus, true);
    document.body.addEventListener("change", handleManualQuantityChange, true);

    const drawer = document.querySelector(".custom-cart-drawer");
    attachConfirmButtonWatchers(drawer);
    updateCartDrawerConfirmButton();

    document.addEventListener("cart-drawer:refreshed", () => {
      const newDrawer = document.querySelector(".custom-cart-drawer");
      attachConfirmButtonWatchers(newDrawer);
      updateCartDrawerConfirmButton();
      /* 🔶 re-highlight static grids when the drawer is recreated */
      const totalQty = getTotalCartItemCount();
      document.querySelectorAll(".cart-item").forEach(line => {
        const grid = line.querySelector(".b2b-pricing-grid");
        if (grid && totalQty > 0) highlightCurrentTier(grid, totalQty);
      });
    });

    // Use a debounced MutationObserver to handle cart updates on the static cart page.
    if (window.location.pathname === "/cart") {
      const cartItemLists = document.querySelectorAll("[data-cart-item-list]");

      if (cartItemLists.length > 0) {
        // This function will run once all the theme's updates are finished.
        const observerCallback = debounce(() => {
          const qty = getTotalCartItemCount();
          document.querySelectorAll(".cart-item").forEach(line => {
            const grid = line.querySelector(".b2b-pricing-grid");

            if (grid && !isNaN(qty) && qty > 0) {
              highlightCurrentTier(grid, qty);
            }
          });
        }, 500); // A 500ms debounce period should be robust enough

        const observer = new MutationObserver(observerCallback);

        cartItemLists.forEach(list => {
          observer.observe(list, {
            childList: true,
            subtree: true,
          });
        });
      }
    }
  }

  // Listen for cart:updated events to refresh volume pricing highlights
  document.addEventListener("cart:updated", function () {
    // Calculate total quantity from current DOM state for accurate highlighting
    const totalQty = getTotalCartItemCount();

    // Update highlights in cart drawer if it's open
    const drawer = document.querySelector("#CartDrawer");
    if (drawer && drawer.classList.contains("active")) {
      drawer.querySelectorAll(".search-flydown--product-card").forEach(productCard => {
        const grid = productCard.querySelector(".b2b-pricing-grid");
        if (grid && totalQty > 0) {
          highlightCurrentTier(grid, totalQty);
        }
      });
    }

    // Update highlights on cart page
    if (window.location.pathname === "/cart") {
      document.querySelectorAll(".cart-item").forEach(line => {
        const grid = line.querySelector(".b2b-pricing-grid");
        if (grid && totalQty > 0) {
          highlightCurrentTier(grid, totalQty);
        }
      });
    }
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initializeCartDrawer);
  } else {
    initializeCartDrawer();
  }
})();
